import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=fbbef53e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=fbbef53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbef53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbbef53e')) {
      api.createRecord('fbbef53e', component.options)
    } else {
      api.reload('fbbef53e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=fbbef53e&scoped=true&", function () {
      api.rerender('fbbef53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h8Dha5MgiPrv/JS/teamMember.vue"
export default component.exports